module.exports = __webpack_public_path__ + "static/media/dj.0c386d22.svg";